// extracted by mini-css-extract-plugin
module.exports = {"root":"root___16fa8","shippingOption":"shippingOption___1w450","greenText":"greenText___2EPIr","deliveryPrice":"deliveryPrice___2L2Bb","loading":"loading___3Gyty"};